/* istanbul ignore file */

import React, { ChangeEvent, FocusEvent, useEffect, useRef, useState } from 'react';

import * as styles from '../styles';

const BLUR_DELAY = 1000;

export interface Props {
  name: string;
  onChange: (e: FocusEvent<HTMLInputElement>) => void;
  value: number;
  valueTextPrefix: string;
  handleRef: (e: HTMLInputElement | null) => void;
}

export const Input = (props: Props) => {
  const { value, name, onChange, valueTextPrefix, handleRef } = props;
  const [stateValue, setStateValue] = useState<string | number>(value);
  const delayedBlurTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    cancelBlur();
    onChange(e);
  };

  const cancelBlur = () => {
    if (delayedBlurTimeout.current) {
      clearTimeout(delayedBlurTimeout.current);
    }
  };

  const scheduleBlur = (e: ChangeEvent) => {
    delayedBlurTimeout.current = setTimeout(
      () => handleBlur(e as unknown as FocusEvent<HTMLInputElement>),
      BLUR_DELAY,
    );
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setStateValue(Number(e.target.value));
    e.persist();
    scheduleBlur(e);
  };

  useEffect(() => {
    if (value != stateValue) {
      setStateValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="range-input-text-field__wrapper">
      <span css={styles.inputTextFieldPrefix} className="range-input-text-field__prefix">
        {valueTextPrefix}
      </span>
      <input
        className="range-input-text-field__input"
        data-testid={`range-input-text-field__input--${name}`}
        name={name}
        ref={handleRef}
        type="number"
        value={stateValue}
        onBlur={handleBlur}
        onChange={handleChange}
        disabled
      />
    </div>
  );
};
